module.exports = __webpack_public_path__ + "img/buttonPlus.fa64c988.svg";